export const AuthResources = {
    tokenResource: '/V1/integration/customer/token',
    passwordResetResource: '/V1/customers/resetPassword',
    registerResource: '/V1/customers',
    requestPasswordResetResource: '/V1/customers/password',
    customerResource: '/V1/customers/me'
};
